<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-2 py-lg-2 pt-lg-2">
      <div class="container">
        <div class="header-body text-center mb-6">
        </div>
      </div>
    </div>

    <div class="container mt-4 mb-6">
      <div class="row">
        <div class="col-3">
          <InfoMenu/>
        </div>
        <div class="col-9">
          <h2>Способы оплаты</h2>
          <h4>Банковской картой</h4>
          <p>Для оплаты подписки "Komandor Premium" с помощью банковской карты в Профиле необходимо
            нажать кнопку "Оплатить картой".
            Оплата происходит через ПАО СБЕРБАНК с использованием банковских карт следующих платёжных
            систем:</p>
          <ul>
            <li>МИР</li>
            <li>VISA International</li>
            <li>Mastercard Worldwide</li>
            <li>JCB</li>
          </ul>
          <p>Для оплаты (ввода реквизитов Вашей карты) Вы будете перенаправлены на платёжный шлюз ПАО СБЕРБАНК. Соединение с платёжным шлюзом и передача информации осуществляется в защищённом режиме с использованием протокола шифрования SSL. В случае если Ваш банк поддерживает технологию безопасного проведения интернет-платежей Verified By Visa, MasterCard SecureCode, MIR Accept, J-Secure для проведения платежа также может потребоваться ввод специального пароля.</p>
          <p>Настоящий сайт поддерживает 256-битное шифрование. Конфиденциальность сообщаемой персональной информации обеспечивается ПАО СБЕРБАНК. Введённая информация не будет предоставлена третьим лицам за исключением случаев, предусмотренных законодательством РФ. Проведение платежей по банковским картам осуществляется в строгом соответствии с требованиями платёжных систем МИР, Visa Int., MasterCard Europe Sprl, JCB.</p>
        </div>
      </div>
    </div>


  </div>
</template>
<script>
  import InfoMenu from './Menu'
  export default {
    name: 'InfoPayment',
    components: { InfoMenu }
  }
</script>
<style></style>
